import React, { useState } from "react";
import { Box, Breadcrumbs, Link, Tab, Tabs, Typography } from "@mui/material";
import { Link as RouterLink, useNavigate } from "react-router-dom";
import Header from "../components/Header";
import GraphqlExplorer from "../components/ApiDevPortal/GraphqlExplorer";
import AccessTokenList from "../components/ApiDevPortal/AccessTokenList";
import DevPortalDocs from "../components/ApiDevPortal/DevPortalDocs";
import { useGraphqlSchema } from "../hooks/useGraphqlSchema";
import { useApiAccessTokens } from "../hooks/useApiAccessTokens";
import "./ApiDevPortal.css";

const TAB_EXPLORER = 0;
const TAB_TOKENS = 1;
const TAB_DOCS = 2;

export default function ApiDevPortal() {
  const navigate = useNavigate();
  const [tab, setTab] = useState(TAB_EXPLORER);
  const { schema, loading: schemaLoading, sdlSource } = useGraphqlSchema();
  const { tokens, loading: tokensLoading, createToken, revokeToken, rotateToken } = useApiAccessTokens();

  const operations = schema?.operations || [];

  return (
    <div className="api-dev-portal">
      <Header />

      <Box
        sx={{
          px: 3,
          py: 2,
          maxWidth: tab === TAB_EXPLORER ? "100%" : 1400,
          mx: "auto",
        }}
      >
        <Breadcrumbs sx={{ mb: 1 }}>
          <Link component={RouterLink} underline="hover" color="inherit" to="/settings">
            Settings
          </Link>
          <Typography color="text.primary">API</Typography>
        </Breadcrumbs>

        <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2 }}>
          <Typography variant="h4">API Dev Portal</Typography>
          <Link
            component="button"
            variant="body2"
            onClick={() => navigate("/settings")}
            sx={{ cursor: "pointer" }}
          >
            Volver a Settings
          </Link>
        </Box>

        <Tabs value={tab} onChange={(_, v) => setTab(v)} sx={{ mb: 2 }}>
          <Tab label="Explorador GraphQL" />
          <Tab label="Tokens de acceso" />
          <Tab label="Documentación" />
        </Tabs>

        {tab === TAB_EXPLORER && (
          schemaLoading ? (
            <Typography>Cargando schema…</Typography>
          ) : (
            <GraphqlExplorer
              operations={operations}
              tokens={tokens}
              sdl={schema?.sdl}
              sdlSource={sdlSource}
            />
          )
        )}

        {tab === TAB_TOKENS && (
          <AccessTokenList
            tokens={tokens}
            loading={tokensLoading}
            onCreate={createToken}
            onRevoke={revokeToken}
            onRotate={rotateToken}
          />
        )}

        {tab === TAB_DOCS && <DevPortalDocs operations={operations} />}
      </Box>
    </div>
  );
}
